module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.10@core-js/library/modules/_fails.js
// module id = 89
// module chunks = 128